import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import {
  Button,
  Col,
  ControlLabel,
  FormGroup,
  Row,
} from 'react-bootstrap';
import SideBar from '../../components/SideBar/SideBar';
import './Diagnose.css';

@inject('diagnoseStore', 'batchStore', 'sidebarStore', 'settingsStore')
@observer
class Diagnose extends Component {
  renderInputs() {
    const buttons = [];
    const { batchStore, diagnoseStore } = this.props;
    const { inputs } = batchStore;

    for (let i = 1; i <= 48; i++) {
      const value = inputs[i - 1];

      buttons.push(
        <Button
          key={`input_${i}`}
          className="btn-diagnose-input"
          bsSize="xs"
          bsStyle={value === '1' ? 'success' : undefined}
          onClick={() => diagnoseStore.setInput(i, value === '1' ? '0' : '1')}
        >
          {i}
        </Button>
      );

    }

    return (
      <div className="diagnose-inputs">
        <h4>Inputs</h4>
        <div className="form-group">{buttons}</div>
      </div>
    );
  }

  renderOutputs() {
    const buttons = [];
    const { diagnoseStore, batchStore } = this.props;
    const { outputs, canEmit } = batchStore;

    for (let i = 1; i <= 96; i++) {
      const value = outputs[i - 1];

      buttons.push(
        <Button
          key={`outputs_${i}`}
          className="btn-diagnose-output"
          bsSize="xs"
          bsStyle={value === '1' ? 'danger' : undefined}
          onClick={() => diagnoseStore.setOutput(i, value === '1' ? '0' : '1')}
        >
          {i}
        </Button>
      );

    }

    return (
      <div className="diagnose-outputs">
        <h4>Outputs</h4>
        <div className="form-group">{buttons}</div>
        {canEmit && (
          <div className="form-group">
            <Button
              bsSize="sm"
              bsStyle="info"
              className="btn-diagnose-test"
              onClick={() => diagnoseStore.setAllOutputs('1')}
            >
            All Outputs On
            </Button>
            <Button
              bsSize="sm"
              bsStyle="info"
              className="btn-diagnose-test"
              onClick={() => diagnoseStore.setAllOutputs('0')}
            >
            All Outputs Off
            </Button>
            {diagnoseStore.isTesting ? (
              <Button
                bsSize="sm"
                bsStyle="info"
                className="btn-diagnose-test"
                onClick={diagnoseStore.stopOutputTest}
              >
              Stop Test
              </Button>
            ) : (
              <Button
                bsSize="sm"
                bsStyle="info"
                className="btn-diagnose-test"
                onClick={diagnoseStore.startOutputTest}
              >
              Auto Test
              </Button>
            )}
          </div>
        )}
      </div>
    );
  }

  renderChannels() {
    const buttons = [];
    const weightButtons = [];
    const { batchStore, diagnoseStore } = this.props;
    const { channels, weightsStatus, isDemo } = batchStore;
    const { editedChanel } = diagnoseStore;

    for (let i = 1; i <= 16; i++) {
      buttons.push(
        <Button
          key={`channels_${i}`}
          className="btn-diagnose-channel"
          bsSize="xs"
          bsStyle={editedChanel === i ? 'info' : undefined}
          onClick={() => diagnoseStore.editChanel(i)}
        >
          {channels[i - 1]}
        </Button>
      );
      const value = weightsStatus[i - 1];
      weightButtons.push(
        <Button
          key={`channels_status_${i}`}
          className="btn-diagnose-channel-status"
          bsSize="xs"
          bsStyle={value === '1' ? 'danger' : value === '2' ? 'warning' : undefined}
        >
          {i}
        </Button>
      );

    }

    return (
      <div className="diagnose-channels">
        <h4>Channels</h4>
        <div className="form-group">{weightButtons}</div>
        <div className="form-group">{buttons}</div>
        {isDemo && editedChanel !== null && (
          <FormGroup>
            <ControlLabel>Set weight</ControlLabel>
            <input
              type="number"
              defaultValue={channels[editedChanel-1] || 0}
              onKeyUp={diagnoseStore.saveChanelValue}
              className="form-control input-sm"
            />
          </FormGroup>
        )}
      </div>
    );
  }

  renderMeters() {
    const metersStatusButtons = [];
    const metersButtons = [];
    const { batchStore, diagnoseStore } = this.props;
    const { metersStatus, meters, isDemo } = batchStore;
    const { editedMeter } = diagnoseStore;

    for (let i = 1; i <= 48; i++) {
      const value = metersStatus[i - 1];
      metersStatusButtons.push(
        <Button
          data-e2e-id={`btn-diagnose-meter-status-${i}`}
          key={`meters_status_${i}`}
          className="btn-diagnose-meter-status"
          bsSize="xs"
          bsStyle={value === '1' ? 'danger' : value === '2' ? 'warning' : undefined}
          onClick={() => diagnoseStore.setMeterStatus(i)}
        >
          {i}
        </Button>
      );
      metersButtons.push(
        <Button
          data-e2e-id={`btn-diagnose-meter-${i}`}
          key={`meters_${i}`}
          className="btn-diagnose-meter"
          bsSize="xs"
          bsStyle={editedMeter === i ? 'info' : undefined}
          onClick={() => diagnoseStore.editMeter(i)}
        >
          {meters[i - 1]}
        </Button>
      );

    }

    return (
      <div className="diagnose-channels">
        <h4>Meters</h4>
        <div className="form-group">{metersStatusButtons}</div>
        <div className="form-group">{metersButtons}</div>

        {isDemo && editedMeter !== null && (
          <FormGroup>
            <ControlLabel>Set meter</ControlLabel>
            <input
              data-e2e-id="inp-diagnose-meter"
              type="number"
              defaultValue={meters[editedMeter-1] || 0}
              onKeyUp={diagnoseStore.saveMeterValue}
              className="form-control input-sm"
            />
          </FormGroup>
        )}
      </div>
    );
  }

  renderAnalogInputs() {
    const analogInputsButtons = [];
    const { batchStore, diagnoseStore } = this.props;
    const { isDemo, analogInputs } = batchStore;
    const { editedAnalogInput } = diagnoseStore;

    for (let i = 1; i <= analogInputs?.length; i++) {
      analogInputsButtons.push(
        <Button
          key={`analog_inputs_${i}`}
          className="btn-diagnose-channel"
          bsSize="xs"
          bsStyle={editedAnalogInput === i ? 'info' : undefined}
          onClick={() => diagnoseStore.editAnalogInput(i)}
        >
          {analogInputs[i - 1]}
        </Button>
      );

    }

    return (
      <div className="diagnose-channels">
        <h4>Analog Inputs</h4>
        <div className="form-group">{analogInputsButtons}</div>

        {isDemo && editedAnalogInput !== null && (
          <FormGroup>
            <ControlLabel>Set analog input</ControlLabel>
            <input
              type="number"
              step="0.01"
              defaultValue={analogInputs[editedAnalogInput-1] || 0}
              onKeyUp={diagnoseStore.saveAnalogInputValue}
              className="form-control input-sm"
            />
          </FormGroup>
        )}
      </div>
    );
  }

  renderAnalogOutputs() {
    const analogOutputsButtons = [];
    const { batchStore, diagnoseStore } = this.props;
    const { isDemo, analogOutputs } = batchStore;
    const { editedAnalogOutput } = diagnoseStore;

    for (let i = 1; i <= 4; i++) {
      analogOutputsButtons.push(
        <Button
          key={`analog_outputs_${i}`}
          className="btn-diagnose-channel"
          bsSize="xs"
          bsStyle={editedAnalogOutput === i ? 'info' : undefined}
          onClick={() => diagnoseStore.editAnalogOutput(i)}
        >
          {analogOutputs[i - 1]}
        </Button>
      );

    }

    return (
      <div className="diagnose-channels">
        <h4>Analog Outputs</h4>
        <div className="form-group">{analogOutputsButtons}</div>

        {isDemo && editedAnalogOutput !== null && (
          <FormGroup>
            <ControlLabel>Set analog output</ControlLabel>
            <input
              type="number"
              defaultValue={analogOutputs[editedAnalogOutput-1] || 0}
              onKeyUp={diagnoseStore.saveAnalogOutputValue}
              className="form-control input-sm"
            />
          </FormGroup>
        )}
      </div>
    );
  }

  render() {
    const { batchStore, sidebarStore, settingsStore } = this.props;
    const { canEmit, ticks, pacVersion, pacVersionEmitter, pacConnected, isDemo, isTestMode, indicatorError, proxyVersion, proxyVersionEmitter } = batchStore;

    return (
      <SideBar type="diagnose" icon={'fa-medkit'} title={'Diagnose'}>
        {sidebarStore.isOpen('diagnose') && (
          <Row>
            <Col sm={12}>
              <h4 className="demo-tick">
                {isDemo ? <strong className="text-danger">DEMO </strong> : ''}
                {isTestMode ? <strong className="text-info">TEST MODE </strong> : ''}
                {pacVersion && pacVersion.version
                  ? <div>PAC: {pacVersion.firmware}, {pacVersion.version}, {pacVersion.uid}, {ticks}</div>
                  : ''
                }
                {proxyVersion
                  ? <div>PROXY: {proxyVersion}</div>
                  : ''
                }
                {!canEmit && pacVersionEmitter && pacVersionEmitter.version
                  ? (
                    <div
                      className="text-info">PAC: {pacVersionEmitter.firmware}, {pacVersionEmitter.version}, {pacVersionEmitter.uid}
                    </div>
                  )
                  : ''
                }
                {!canEmit && proxyVersionEmitter
                  ? <div className="text-info">PROXY: {proxyVersionEmitter}</div>
                  : ''
                }
                <div>API: {settingsStore.apiVersion}</div>
              </h4>
            </Col>
            <Col sm={12}>
              {this.renderInputs()}
              {this.renderOutputs()}
              {this.renderChannels()}
              {this.renderMeters()}
              {this.renderAnalogInputs()}
              {this.renderAnalogOutputs()}
              {!isDemo && !pacConnected && indicatorError && <p className="text-danger">Plant disconnected!</p>}
            </Col>
          </Row>
        )}
      </SideBar>
    );
  }
}

export default Diagnose;
